<template>
  <div class="home">
    <div class="turnClass">
      <div id="flipbook">
          <div v-for="(item,index) in imgUrl" :key="item.index"
          style="background-color: #ffffff;"
          >
          <img :src="item.imgurl" style="width: 100%;height: 10rem !important;" />
         第{{index+1}}篇：
          中豫港务集团亮相第二届“国资杯”职工健身运动会
发布时间：2025-09-20 10:26 来源：中豫港务党建 点击量：9

9月20日上午，龙子湖畔彩旗招展、活力涌动，第二届“国资杯”职工健身运动会在此盛大开幕。



省政府国资委主任吴祖明，省委宣传部副部长李新建，省总工会副主席高颖嘉，奥运冠军、省体育局群众体育处处长孙甜甜，本届运动会组委会成员单位领导等出席开幕式。全省国资国企系统运动员、裁判员、干部职工近千人齐聚现场，共同开启这场“活力+奋斗”的体育盛会。

本届运动会以“突破·超越 豫企新征程”为主题，体现出国资国企事业在发展布局、体制机制上求突破，在改革创新、对标一流上勇超越的精神，彰显了在“十四五”规划圆满收官、“十五五”规划全面擘画中，开启河南国资国企改革新征程的决心。

中豫港务集团党委副书记、工会主席康书霞带队参加开幕式。



开幕式结束后，各代表队参加了5公里健步走和拔河比赛。中豫港务代表团的队员们精神抖擞、相互鼓励，伴着凉爽的秋风，圆满完成了5.2公里的行程。拔河比赛中，加油声此起彼伏、气氛热烈，中豫港务集团代表队取得了第七名的优异成绩。
          </div>
      </div>
    </div>
  </div>


</template>

<script>
//turn.js
import turn from '../utils/turn.js'

export default {
  name: 'Home',
  data(){
    return{
        imgUrl:[
          {imgurl:'https://www.zygwjt.cn:8443/materials/upload/rotation/eac73afea69d400994a808ce15992bf4.png',index:1},
          {imgurl:'https://www.zygwjt.cn:8443/materials/upload/rotation/15a20f47468d433baafb05aaad352c84.jpg',index:2},
          {imgurl:'https://www.zygwjt.cn:8443/materials/upload/rotation/074f3d56df4448819afd14d1c42e3a9d.png',index:3},
          {imgurl:'https://www.zygwjt.cn:8443/materials/upload/rotation/eac73afea69d400994a808ce15992bf4.png',index:4},
        ]
    }
  },
  methods:{
      onTurn(){
        this.$nextTick(()=>{
        $("#flipbook").turn({
        autoCenter: true,
        height:646,
        width:'90vw',
        });
        })
    
      }
  },
  mounted(){
   this.onTurn();
  }
}
</script>
<style lang="scss">
  *{
    margin: 0;
    padding: 0;
  }
  .home{
    width: 100vw;
    height: 100vh;
    .turnClass{
      display: flex;
      margin: 0px auto;
      width: 45vw;
      height: 646px;
      padding: calc((100vh - 646px)/2) 0;
      overflow: hidden;
    }
  }
</style>
 